import React from 'react';
import { Routes, Route } from 'react-router-dom';
import GameList from '../components/games/GameList';
import GameDetail from '../components/games/GameDetail';
import GameForm from '../components/admin/GameForm';
import { AdminRoute } from './PrivateRoutes';

const GameRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<GameList />} />
      <Route path="/:id" element={<GameDetail />} />
      
      {/* Admin Routes */}
      <Route 
        path="/admin/games/new" 
        element={
          <AdminRoute>
            <GameForm />
          </AdminRoute>
        } 
      />
      <Route 
        path="/admin/games/edit/:id" 
        element={
          <AdminRoute>
            <GameForm isEditMode />
          </AdminRoute>
        } 
      />
    </Routes>
  );
};

export default GameRoutes;
